import React from 'react';
import { Icon } from './Icon.js';
export const IconFlag3Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8.561,4.5l2.22-2.22c.214-.214.279-.537.163-.817s-.39-.463-.693-.463H3v7h7.25c.303,0,.577-.183.693-.463s.052-.603-.163-.817l-2.22-2.22Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m2.75,12c-.414,0-.75-.336-.75-.75V.75c0-.414.336-.75.75-.75s.75.336.75.75v10.5c0,.414-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconFlag3Fill12.js.map